import { ErpOrderDiscountedPrice } from '@ca/common'
import { extractDiscountOrders } from '../hooks/utils/discountedPrice'

/**
 * Resolves what a discount removal did to the prices.
 * The ERP can answer without them, and restoring the gross amount would drop any
 * discount still on the order, so clear instead and let `amount` govern again.
 */
const resolveDiscountPrices = (
  res: unknown,
  orderIds: number[]
): { prices: ErpOrderDiscountedPrice[]; clearedIds: number[] } => {
  const prices = extractDiscountOrders(res)
  if (prices?.length) {
    return { prices, clearedIds: [] }
  }
  return { prices: [], clearedIds: orderIds }
}

export default resolveDiscountPrices
